import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BaseUrl = process.env.REACT_APP_BASEURL_SERVER;

export const PrivacyPolicyAPI = createApi({
  reducerPath: "PrivacyPolicyAPI",
  baseQuery: fetchBaseQuery({
    baseUrl: BaseUrl,
    prepareHeaders: (headers) => {
      headers.set("Accept", "application/json");
      headers.set("Content-Type", "application/json");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getPrivacyPolicyData: builder.query({
      query: () => `/privacy-policy/show-privacy`,
    }),
    getTermsandCondtionData: builder.query({
      query: () => `terms-conditions/show-terms`,
    }),
    getRefundPolicyData: builder.query({
      query: () => `refund-policy/show-refund`,
    }),
    getShippingPolicyData: builder.query({
      query: () => `shipping-policy/show-shipping`,
    }),
  }),
});

export const { 
  useGetPrivacyPolicyDataQuery,
useGetTermsandCondtionDataQuery,
useGetRefundPolicyDataQuery,
useGetShippingPolicyDataQuery
} = PrivacyPolicyAPI;
